import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as classNames from 'classnames';

interface IProps {
  children?: any;
  width: number;
}

interface IState {
  hideButtons?: boolean;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
  offset?: number;
}

const DELTA_OFFSET: number = 15;
const EXIT_BUTTON_WIDTH: number = 32; // width of exit button

export class NavTabControls extends React.Component<IProps, IState> {
  public state: IState = {
    hideButtons: true,
    prevDisabled: true,
    nextDisabled: true,
    offset: 0,
  };
  private listWidth: number = 0;

  public componentDidMount(): void {
    this.setListWidth();
  }

  public componentDidUpdate(prevProps: IProps): void {
    if (this.props.children.length !== prevProps.children.length) {
      this.setListWidth();
      this.onWidthChange(this.props.width);
    }
    if (this.props.width !== prevProps.width) {
      this.onWidthChange(this.props.width);
    }
  }

  public render(): React.ReactElement<any> {
    const {hideButtons, offset, prevDisabled, nextDisabled} = this.state;
    const {children} = this.props;

    return <div className={classNames('nav-tab-controls', {'nav-tab-controls--collapsed': this.hasManyTabs() && !hideButtons})}>
      <span className={classNames('nav-tab-buttons__button', {'nav-tab-buttons__button_disabled': prevDisabled})} onClick={this.onPrev}>
        <span className={'icon icon--arrow icon--left'}/>
      </span>
      <div className={'nav-tab-list'} ref={'tab-list-container'}>
        <div className={'nav-tab-list-i'} ref={'tab-list'} style={{transform: `translateX(${-offset}px)`}}>{children}</div>
      </div>
      <span className={classNames('nav-tab-buttons__button', {'nav-tab-buttons__button_disabled': nextDisabled})} onClick={this.onNext}>
        <span className={'icon icon--arrow'}/>
      </span>
    </div>;
  }

  private setListWidth = (): void => {
    const element = ReactDOM.findDOMNode(this.refs['tab-list']);
    this.listWidth = element.getBoundingClientRect().width;
  };

  private hasManyTabs(): boolean {
    return this.props.children.length > 1;
  }

  /* tslint:disable:no-unused-expression */
  private onWidthChange(width: number): void {
    const {hideButtons} = this.state;

    if (width > this.listWidth + EXIT_BUTTON_WIDTH) {
      hideButtons || this.setState({
        hideButtons: true,
        prevDisabled: true,
        nextDisabled: false,
        offset: 0,
      });
    } else {
      hideButtons && this.setState({
        hideButtons: false,
        prevDisabled: true,
        nextDisabled: false,
        offset: 0,
      });
    }
  }
  /* tslint:enable:no-unused-expression */

  private onPrev = (): void => {
    const offset = Math.max(this.state.offset - DELTA_OFFSET, 0);
    this.setState({
      prevDisabled: offset === 0,
      nextDisabled: false,
      offset,
    });
  };

  private onNext = (): void => {
    const containerWidth = ReactDOM.findDOMNode(this.refs['tab-list-container']).getBoundingClientRect().width;
    const maxOffset = this.listWidth - containerWidth;
    const offset = Math.min(this.state.offset + DELTA_OFFSET, maxOffset);
    this.setState({
      prevDisabled: false,
      nextDisabled: offset === maxOffset,
      offset,
    });
  };
}
